var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZec = function SvgZec(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zec_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4B728",
    d: "M22 44c12.15 0 22-9.85 22-22S34.15 0 22 0 0 9.85 0 22s9.85 22 22 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.757 27.288h8.658v4.607h-5.328c.088 1.317.134 2.54.222 3.855h-4.484v-3.809h-5.33c0-1.503-.177-3.007.09-4.418.133-.752.932-1.41 1.42-2.068q2.533-3.166 5.107-6.298c.667-.8 1.332-1.553 2.087-2.445h-8.305v-4.607h4.93V8.25h4.307v3.76h5.374c0 1.552.177 3.056-.09 4.467-.133.752-.932 1.41-1.464 2.068a635 635 0 0 1-5.107 6.298 51 51 0 0 1-2.087 2.445"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zec_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgZec;